import React from "react";
import { GuidesCard } from "@trussle/external-components";
import { PanelWrapper } from "../../../../PanelWrapper";
import { IBlock } from "../../../../../types/IBlock";
import { GatsbyImageOrSvg } from "../../../../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";
import { IContentfulBackgroundColour } from "../../../../../types/IContentfulBackgroundColour";

import "./styles.scss";

export interface IPullOutBlocksPanelGuidesProps {
  title?: string;
  bgColour: IContentfulBackgroundColour;
  blocks: IBlock[];
}

export const PullOutBlocksPanelGuides: React.FC<IPullOutBlocksPanelGuidesProps> = ({ title, bgColour, blocks }) => {
  if (!blocks) {
    return null;
  }

  return (
    <PanelWrapper backgroundColour={bgColour} className="pullOutBlocksPanelGuides" isBetterV2>
      <h2 className="title">{title}</h2>
      <div className="guidesWrapper">
        {blocks.map(({
          backgroundColour, title: guideTitle, subtitle, description, image, link,
        }) => {
          if (!guideTitle || !subtitle || !description || !image || !link) {
            return null;
          }

          return (
            <GuidesCard
              variant={backgroundColour as "purple" | "green" | "orange"}
              title={guideTitle}
              subtitle={subtitle}
              text={description}
              icon={
              () => (
                <GatsbyImageOrSvg
                  loading="lazy"
                  image={image}
                  alt={image.title}
                />
              )
            }
              link={link.url}
              classOverrides={{
                guidesCard: "guidesCard",
                guidesCardHeader: "guidesCardHeader",
                guidesCardText: "guidesCardText",
                guidesCardTitle: "guidesCardTitle",
              }}
            />
          );
        })}
      </div>
    </PanelWrapper>
  );
};
